module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/contact.svg?a11c6a644a8eec59cae47b6686a91b9a";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/contact.svg
// module id = 13
// module chunks = 0